<div class="modal-content">
  <div class="modal-header">
    <h1>Board Statistics Report</h1>
    <button type="button" class="btn-close" (click)="activeModal.dismiss()">×</button>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="activeModal.dismiss()">Close</button>
    <button type="button" class="btn btn-primary" (click)="exportReport()" [disabled]="loading">
      <i class="ri-download-line me-1"></i>
      {{ loading ? 'Generating...' : 'Export Report' }}
    </button>
  </div>

  <div class="modal-body">
    <!-- Error Message -->
    <div *ngIf="error" class="alert alert-danger">
      {{ error }}
    </div>

    <form [formGroup]="reportForm" (ngSubmit)="exportReport()">
      <!-- Date Selection Card -->
      <div class="card">
        <div class="card-header">
          <h2>Date Range</h2>
        </div>
        <div class="card-body">
          <!-- Quick Select Buttons -->
          <div class="quick-select-buttons">
            <button type="button" class="btn btn-outline-primary" (click)="setPresetDates('ytd')">
              <i class="ri-calendar-line"></i>
              Year to Date
            </button>
            <button type="button" class="btn btn-outline-primary" (click)="setPresetDates('mtd')">
              <i class="ri-calendar-line"></i>
              Month to Date
            </button>
            <button type="button" class="btn btn-outline-primary" (click)="setPresetDates('wtd')">
              <i class="ri-calendar-line"></i>
              Week to Date
            </button>
          </div>

          <!-- Custom Date Range -->
          <div class="date-range">
            <div class="form-group">
              <label>Start Date</label>
              <input type="date" class="form-control" formControlName="startDate" (change)="loadReport()">
            </div>
            <div class="form-group">
              <label>End Date</label>
              <input type="date" class="form-control" formControlName="endDate" (change)="loadReport()">
            </div>
          </div>
        </div>
      </div>

      <!-- Sales Rep Selection -->
      <!-- <div class="card mt-3">
        <div class="card-header">
          <h2>Filters</h2>
        </div>
        <div class="card-body">
          <div class="form-group">
            <label>Sales Representative</label>
            <select class="form-select" formControlName="selectedSalesRep" (change)="loadReport()">
              <option value="">All Sales Reps</option>
              <option *ngFor="let rep of salesReps" [value]="rep.id">
                {{rep.firstName}} {{rep.lastName}}
              </option>
            </select>
          </div>
        </div>
      </div> -->
    </form>

    <!-- Results Preview -->
    <div class="stats-preview mt-4">
      <h2>Results Preview</h2>
      
      <div *ngIf="boardStats.length === 0" class="text-center p-4">
        <p class="text-muted">No data available for the selected criteria</p>
      </div>

      <div *ngIf="boardStats.length > 0" class="table-container">
        <!-- Mobile Cards View -->
        <div class="stats-cards d-md-none">
          <div class="stat-card" *ngFor="let stat of boardStats">
            <div class="stat-card__header">
              <span class="stat-card__label">Asset Tag</span>
              <span class="stat-card__value">{{ stat.board?.assetTag }}</span>
            </div>
            <div class="stat-card__body">
              <div class="stat-row">
                <span class="stat-label">Game</span>
                <span class="stat-value">{{ stat.board?.installedGamePackage?.name }}</span>
              </div>
              <div class="stat-row">
                <span class="stat-label">Location</span>
                <span class="stat-value">{{ stat.board?.location?.locationName }}</span>
              </div>
              <div class="stat-row">
                <span class="stat-label">Cash In</span>
                <span class="stat-value text-success">{{ stat.cashInDiff | currency }}</span>
              </div>
              <div class="stat-row">
                <span class="stat-label">Cash Out</span>
                <span class="stat-value text-danger">{{ stat.cashOutDiff | currency }}</span>
              </div>
              <div class="stat-row">
                <span class="stat-label">Net</span>
                <span class="stat-value" [ngClass]="{'text-success': stat.profit > 0, 'text-danger': stat.profit < 0}">
                  {{ stat.profit | currency }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Desktop Table View -->
        <div class="table-responsive d-none d-md-block">
          <table class="table">
            <thead>
              <tr>
                <th>Asset Tag</th>
                <th>Game</th>
                <th>Location</th>
                <th class="text-end">Cash In</th>
                <th class="text-end">Cash Out</th>
                <th class="text-end">Net</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let stat of boardStats">
                <td class="text-nowrap">{{ stat.board?.assetTag }}</td>
                <td>{{ stat.board?.installedGamePackage?.name }}</td>
                <td>{{ stat.board?.location?.locationName }}</td>
                <td class="text-end text-success">{{ stat.cashInDiff | currency }}</td>
                <td class="text-end text-danger">{{ stat.cashOutDiff | currency }}</td>
                <td class="text-end" [ngClass]="{'text-success': stat.profit > 0, 'text-danger': stat.profit < 0}">
                  {{ stat.profit | currency }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>